import StickyFill from 'stickyfilljs';
export const init = () => {
	//stickybits('.js-sticky');
	var elements = document.querySelectorAll('.js-sticky');
	StickyFill.add(elements);
};
